import { ConfiguredCarCarCode } from '@oneaudi/onegraph-client';

export function PoaTrigger(chatBotId: string, audiCode: ConfiguredCarCarCode) {
	if (typeof window.acquireIO !== 'undefined') {
		window?.acquireIO.max('text', chatBotId, audiCode.id, false, 'bot');
	} else {
		console.error('Could not start chatbot');
	}
}
